import { render } from "./EmailComposer.vue?vue&type=template&id=1fd2ce61"
import script from "./EmailComposer.vue?vue&type=script&lang=js"
export * from "./EmailComposer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__